/* eslint-disable import/no-unresolved */
import DownloadAndVerify from "src/components/ReviewDetails/DownloadAndVerify";
import Header from "src/shared/Header";
// import ReviewDetails from "../../components/ReviewDetails";

function DownloadAndVerifyDetailsPages() {
  return (
    <div>
      <Header isEnable />
      <DownloadAndVerify />
    </div>
  );
}

export default DownloadAndVerifyDetailsPages;
